import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
  manualLoading: boolean;
  errorToast: { visible: boolean; message: string } | null;
}

const initialState: UiState = {
  manualLoading: false,
  errorToast: null,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setManualLoading(state, action: PayloadAction<boolean>) {
      state.manualLoading = action.payload;
    },
    showErrorToast(state, action: PayloadAction<string>) {
      state.errorToast = { visible: true, message: action.payload };
    },
    hideErrorToast(state) {
      state.errorToast = null;
    },
  },
});

export const { setManualLoading, showErrorToast, hideErrorToast } = uiSlice.actions;
export default uiSlice.reducer;
